import { InjectionToken } from '@angular/core';

// A mock session sends its API requests here instead of the real API: no backend serves this path, so a request
// the mocks did not answer can only fail, never return real data. The worker gets it in its URL (start-mock-worker.ts).
export const MOCK_API_BASE_URL = '/mock-api';

// The real API's base URL, which a mock session no longer has in `environment`.
export const REAL_API_BASE_URL = new InjectionToken<string>('REAL_API_BASE_URL');
